import {
  Action,
  ActionType,
  MiniStressTypePDFDownloadResponse,
} from "models/stressCheck/miniStressTypeDownloadPdf";
import createReducer from "redux/createReducer";

export interface MiniStressPDFDownloadReducerType {
  loading: boolean;
  error?: string;
  miniStressPdfDownloadResponse?: MiniStressTypePDFDownloadResponse;
}

const defaultState: MiniStressPDFDownloadReducerType = {
  loading: false,
  error: undefined,
  miniStressPdfDownloadResponse: undefined,
};

export const miniStressPdfDownloadReducer =
  createReducer<MiniStressPDFDownloadReducerType>(defaultState, {
    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF](
      state: MiniStressPDFDownloadReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF_ERROR](
      state: MiniStressPDFDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF_SUCCESS](
      state: MiniStressPDFDownloadReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressPdfDownloadResponse: action.payload,
      };
    },

    [ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF_RESET_DATA](
      state: MiniStressPDFDownloadReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        miniStressPdfDownloadResponse: [],
      };
    },
  });
